import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

const benefits = [
  {
    icon: 'ri-speed-up-line',
    title: 'Compare Products Faster',
    desc: 'The mulebuy spreadsheet system lets you compare hundreds of products side by side in seconds, saving you hours of manual browsing.',
  },
  {
    icon: 'ri-error-warning-line',
    title: 'Reduce Purchasing Mistakes',
    desc: 'With structured mulebuy spreadsheet data, you can verify product details before buying, cutting down costly ordering errors.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Track Orders Efficiently',
    desc: 'Every order flows through the mulebuy spreadsheet tracking system, giving you real-time visibility from purchase to delivery.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Pricing Transparency',
    desc: 'The mulebuy spreadsheet platform shows all fees upfront — no hidden costs, no surprises at checkout.',
  },
];

export default function WhySection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 text-center mb-5">
          Why Mulebuy Spreadsheet Matters
        </h2>
        <p className="text-base text-foreground-600 text-center max-w-2xl mx-auto mb-12 md:mb-16 leading-relaxed">
          The mulebuy spreadsheet system is changing how global users discover and purchase products through agent-based shopping workflows. With the right mulebuy spreadsheet guide, you can shop smarter and safer.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-xl p-5 md:p-6 hover:bg-background-200/70 transition-colors"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/mulebuy-spreadsheet-complete-guide"
            className="inline-flex px-7 py-3 bg-primary-500 text-background-50 rounded-md font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Start Learning Mulebuy Spreadsheet
          </Link>
        </div>
      </div>
    </section>
  );
}